import signatureStella from "assets/signatureStella.png";
import Button from "components/base/Button";
import { Input } from "components/base/Form";

const GenerateDocCertificateFields = ({
  form,
  onChange,
  imageUrls,
  docReports,
  addDocReportHandler,
  changeDocReportHandler,
  removeDocReportHandler,
}) => {
  return (
    <>
      <section className="space-y-4">
        <div className="flex items-start justify-between gap-6">
          <div>
            <h3>EC Declaration of Conformity</h3>
            <h5>In accordance with EN ISO 17050-1:2004</h5>
          </div>
          <img
            src="https://cdn.waboba.com/public/waboba-logo-w-waboba.png"
            alt="Waboba"
            className="h-12 ml-auto py-2"
          />
        </div>
      </section>

      <section className="space-y-4">
        <div>
          This declaration of conformity is issued under the sole responsibility
          of the manufacturer.
        </div>
        <div className="pt-4">
          <div>
            <span className="font-semibold">We </span>
            <span>WABOBA AB</span>
          </div>
          <div>
            <span className="font-semibold">of </span>
            <span>Hornsgatan 110 117 26 Stockholm Sweden</span>
          </div>
        </div>
        <div>
          <label className="font-semibold">
            in accordance with the following Directive(s):
          </label>
          <Input
            className="w-full mt-2"
            value={form.docDirectives}
            onChange={(e) => onChange("docDirectives", e.target.value)}
          />
        </div>
        <div className="font-semibold">hereby declare that:</div>
      </section>

      <section className="-mx-2">
        <table>
          <tbody>
            <tr>
              <td className="w-32">
                <label>Name:</label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={form.docName}
                  onChange={(e) => onChange("docName", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Model Number:</label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={form.docModelNumber}
                  onChange={(e) => onChange("docModelNumber", e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      {imageUrls.length > 0 ? (
        <section className="space-y-4">
          <div className="flex flex-wrap gap-3">
            {imageUrls.map((url, index) => (
              <img
                key={`${url}-${index}`}
                src={url}
                alt="Certificate"
                className="w-32 h-32 object-cover rounded border border-gray-200 dark:border-gray-700"
              />
            ))}
          </div>
        </section>
      ) : null}

      <section className="space-y-4">
        <div>
          is in conformity with the applicable requirements of the following
          documents:
        </div>
        <div className="-mx-2">
          <table className="with-line">
            <thead>
              <tr>
                <th>Ref.No.</th>
                <th>Notified Body</th>
                <th>Document No.</th>
                <th>Title</th>
                <th>Edition / Date</th>
                <th className="w-16"></th>
              </tr>
            </thead>
            <tbody>
              {docReports.map((report, index) => (
                <tr key={index}>
                  <td>
                    <Input
                      className="w-full"
                      value={report.refNo}
                      onChange={(e) =>
                        changeDocReportHandler(index, "refNo", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      className="w-full"
                      value={report.notifiedBody}
                      onChange={(e) =>
                        changeDocReportHandler(
                          index,
                          "notifiedBody",
                          e.target.value,
                        )
                      }
                    />
                  </td>
                  <td>
                    <Input
                      className="w-full"
                      value={report.documentNo}
                      onChange={(e) =>
                        changeDocReportHandler(
                          index,
                          "documentNo",
                          e.target.value,
                        )
                      }
                    />
                  </td>
                  <td>
                    <Input
                      className="w-full"
                      value={report.title}
                      onChange={(e) =>
                        changeDocReportHandler(index, "title", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      className="w-full"
                      type="date"
                      value={report.editionDate}
                      onChange={(e) =>
                        changeDocReportHandler(
                          index,
                          "editionDate",
                          e.target.value,
                        )
                      }
                    />
                  </td>
                  <td className="text-right">
                    <Button
                      trash
                      onClick={() => removeDocReportHandler(index)}
                      disabled={docReports.length === 1}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Button onClick={addDocReportHandler}>+ Add</Button>
      </section>

      <section className="space-y-6">
        <div>
          I hereby declare that the article named above has been designed to
          comply with the relevant sections of the above referenced
          specifications. The unit complies with all applicable Essential
          Requirements of the Directives.
        </div>

        <div className="-mx-2">
          <table>
            <tbody>
              <tr>
                <td className="w-64">Signed for and on behalf of:</td>
                <td>
                  <img className="h-16" src={signatureStella} alt="Signature" />
                </td>
              </tr>
              <tr>
                <td>Name:</td>
                <td>Stella Huang</td>
              </tr>
              <tr>
                <td>Position:</td>
                <td>Head of Global Operations</td>
              </tr>
              <tr>
                <td>Place:</td>
                <td>Guangzhou, China</td>
              </tr>
              <tr>
                <td>Date:</td>
                <td>
                  <Input
                    className="w-56"
                    type="date"
                    value={form.docSignDate}
                    onChange={(e) => onChange("docSignDate", e.target.value)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default GenerateDocCertificateFields;
